import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ILocation } from '@modmd/data'
import { Box } from 'components/Layout'
import { DEVICE } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import { SignInCard } from 'sharedComponents/SignInCard'

const SignIn = () => {
  const isMobile = !useIsMinDevice(DEVICE.TABLET)
  const history = useHistory()
  const location = useLocation<ILocation>()
  return (
    <Box
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems={!isMobile ? 'center' : undefined}
    >
      <SignInCard
        title="Sign in to your account"
        emailLabel="Email"
        emailPlaceholder="Enter your email"
        passwordLabel="Password"
        passwordPlaceholder="Enter your password"
        forgotPasswordLabel="Forgot Password?"
        signInButtonLabel="Sign in"
        dontHaveAccountLabel="Don’t have an account?"
        onSignInSuccess={() => {
          if (location.state?.from) {
            history.push(location.state.from)
          }
        }}
      />
    </Box>
  )
}

export default SignIn
